module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-09-fa1ad1a040dce35df2826975713531a7.jpg";